import React, { Component } from 'react'
import { Link } from 'react-router'

import ReactCSSTransitionGroup from 'react-addons-css-transition-group'

export default class Features extends Component {
  render() {
    return (
      <ReactCSSTransitionGroup
        transitionName="page"
        transitionAppear={true}
        transitionAppearTimeout={750}
        transitionEnterTimeout={750}
        transitionLeaveTimeout={750}
        className="steps"
        component="section"
      >
        <div className="step step--left">
          <div className="copy">

            <h1>All the socials in one place</h1>
            <h2>No hassles, one app, almost all the socials.</h2>

          </div>
          <h1 className="arrow">↴</h1>
        </div>

        <div className="step step--left">
          <div className="copy">
            <h1>Take control of your privacy</h1>
            <h2>No more eavesdropping or looking at your photos.</h2>
          </div>
          <h1 className="arrow">↴</h1>
        </div>

        <div className="step step--left">
          <div className="copy">
            <h1>Bundles notifications</h1>
            <h2>Relax and get notifications every 5, 15, 30 or 60 minutes</h2>
            <h2></h2>
          </div>
          <h1 className="arrow">↴</h1>
        </div>

        <div className="step step--left">
          <div className="copy">
            <h1>Password managers</h1>
            <h2>Login with 1Password/LastPass</h2>
          </div>
          <h1 className="arrow">↴</h1>
        </div>



        <div className="step step--left">
          <div className="copy">
            <h1>Backendless</h1>
            <h2>I won't collect any information about you. All your data stays on the phone.</h2>
          </div>
        </div>

        <div className="step step--left">
          <div className="copy">
            <h1>Legal?</h1>
            <h2>It should be. It's just a very optimized web-browser. ☻</h2>
          </div>
        </div>

        <Link to="/waitlist" style={{marginTop: '20vh', marginBottom: '20vh'}}>
          <button className="inverted"><h1>Signup to the waitlist</h1></button>
        </Link>
      </ReactCSSTransitionGroup>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/features.js